module.exports = __webpack_public_path__ + "static/media/10.a2d264fa.jpg";